const ViewModeResults = {
  TOC: 'browseTOC',
  EXERCISE: 'exerciseTOC',
} as const;

export default ViewModeResults;
